import { C } from "@/lib/brand";

export default function Button({
  children,
  onClick,
  variant = "primary", // primary | peach | sage | ghost | dark
  type = "button",
  disabled = false,
  block = false,
  size = "md", // sm | md | lg
  testId,
  className = "",
  style: extraStyle = {},
}) {
  const padding = size === "lg" ? "20px 32px" : size === "sm" ? "10px 18px" : "16px 26px";
  const fontSize = size === "lg" ? 14 : size === "sm" ? 11 : 13;

  const variants = {
    primary: { background: C.ink, color: C.cream },
    peach: { background: C.peach, color: C.ink },
    peachDeep: { background: C.peachDeep, color: C.ink },
    sage: { background: C.sage, color: C.ink },
    cream: { background: C.cream, color: C.ink, border: `1.5px solid ${C.ink}` },
    ghost: { background: "transparent", color: C.ink, border: `1.5px solid ${C.ink}` },
    dark: { background: C.ink, color: C.peach },
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      className={`transition-opacity hover:opacity-90 active:opacity-80 disabled:cursor-not-allowed ${className}`}
      style={{
        padding,
        fontSize,
        fontWeight: 800,
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        cursor: disabled ? "not-allowed" : "pointer",
        width: block ? "100%" : "auto",
        opacity: disabled ? 0.5 : 1,
        textAlign: "center",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        ...variants[variant],
        ...extraStyle,
      }}
    >
      {children}
    </button>
  );
}
